// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__28al8","paramInput":"JobSimulator_paramInput__1ZHmS","input":"JobSimulator_input__1ZmQ_"};